// extracted by mini-css-extract-plugin
export default {"cardBody":"EvidenceDiaryEdit_cardBody__14lmC","sectionLabel":"EvidenceDiaryEdit_sectionLabel__3hWif","readOnly":"EvidenceDiaryEdit_readOnly__h+Pq2"};